import { mapState } from "vuex";
import { mapActions } from 'vuex';
import { debounce } from 'throttle-debounce';

function autocomplete(autocompleteModule, addressType = 'billing') {
    return {
        data() {
            return {
                predictions: [],
                serviceLoaded: false,
                service: null,
                placeService: null,
                currentCountryIso: '',
                sessionToken: {}
            };
        },
        watch: {
            service(newVal) {
                if (newVal) {
                    this.serviceLoaded = true;
                }
            }
        },
        mounted() {
            this.initPlaces();
        },
        methods: {
            ...mapActions({
                setField: function (dispatch, payload) {
                    return dispatch(autocompleteModule + '/setField', payload);
                }
            }),
            initPlaces() {
                this.sessionToken = new window.google.maps.places.AutocompleteSessionToken();
                this.service = new window.google.maps.places.AutocompleteService();
                this.placeService = new window.google.maps.places.PlacesService(
                    document.createElement('div') // Requires an element to "bind" to
                );
            },
            callAutoComplete: debounce(300, function (e) {
                if (e.target.value !== '') {
                    let componentRestrictions = this.currentCountryIso
                        ? { country: this.currentCountryIso }
                        : {};
                    let houseNumber = this[addressType + '_house_number'];
                    this.serviceLoaded &&
                        this.service.getPlacePredictions(
                            {
                                input: houseNumber + ' ' + e.target.value,
                                componentRestrictions,
                                sessionToken: this.sessionToken,
                                types: ['address']
                            },
                            (predictions, status) => {
                                if (
                                    status !=
                                    google.maps.places.PlacesServiceStatus.OK
                                ) {
                                    return;
                                }

                                this.predictions = [];

                                predictions.forEach(prediction => {
                                    this.predictions.push(prediction);
                                });
                            }
                        );
                }
            }),
            fillPostcode(filledFields, tempPostcode, comp) {
                if (comp.types.indexOf('postal_code') !== -1) {
                    tempPostcode.main = comp.short_name;
                } else if (comp.types.indexOf('postal_code_prefix') !== -1) {
                    tempPostcode.prefix = comp.short_name;
                } else if (comp.types.indexOf('postal_code_suffix') !== -1) {
                    tempPostcode.suffix = comp.short_name;
                }
            },
            fillStreet(filledFields, tempStreet, comp) {
                if (comp.types.indexOf('route') !== -1) {
                    tempStreet.push(comp.long_name);
                }

                if (tempStreet.length) {
                    this.setField({
                        identifier: `${this.autocompleteIdentifier}_street`,
                        data: tempStreet.join(' ')
                    });
                } else {
                    this.setField({
                        identifier: `${this.autocompleteIdentifier}_street`,
                        data: ''
                    });
                }
            },
            fillState(filledFields, comp) {
                if (comp.types.indexOf('administrative_area_level_2') !== -1) {
                    this.setField({
                        identifier: `${this.autocompleteIdentifier}_state`,
                        data: comp.long_name
                    });
                    filledFields[`${this.autocompleteIdentifier}_state`] = true;
                } else if (
                    comp.types.indexOf('administrative_area_level_1') !== -1 &&
                    !filledFields[`${this.autocompleteIdentifier}_state`]
                ) {
                    this.setField({
                        identifier: `${this.autocompleteIdentifier}_state`,
                        data: comp.long_name
                    });
                    filledFields[`${this.autocompleteIdentifier}_state`] = true;
                } else if (
                    !filledFields[`${this.autocompleteIdentifier}_state`]
                ) {
                    this.setField({
                        identifier: `${this.autocompleteIdentifier}_state`,
                        data: ''
                    });
                }
            },
            fillCity(filledFields, comp) {
                if (comp.types.indexOf('locality') !== -1) {
                    this.setField({
                        identifier: `${this.autocompleteIdentifier}_city`,
                        data: comp.long_name
                    });
                    filledFields[`${this.autocompleteIdentifier}_city`] = true;
                } else if (
                    comp.types.indexOf('postal_town') !== -1 &&
                    !filledFields[`${this.autocompleteIdentifier}_city`]
                ) {
                    this.setField({
                        identifier: `${this.autocompleteIdentifier}_city`,
                        data: comp.long_name
                    });
                    filledFields[`${this.autocompleteIdentifier}_city`] = true;
                } else if (
                    !filledFields[`${this.autocompleteIdentifier}_city`]
                ) {
                    this.setField({
                        identifier: `${this.autocompleteIdentifier}_city`,
                        data: ''
                    });
                }
            },
            setPlaces(components) {
                let tempStreet = [];
                let tempPostcode = {
                    prefix: '',
                    main: '',
                    suffix: ''
                };

                let filledFields = {
                    [`${this.autocompleteIdentifier}_postcode`]: false,
                    [`${this.autocompleteIdentifier}_street`]: false,
                    [`${this.autocompleteIdentifier}_state`]: false,
                    [`${this.autocompleteIdentifier}_city`]: false
                };

                components.forEach(comp => {
                    this.fillPostcode(filledFields, tempPostcode, comp);
                    this.fillStreet(filledFields, tempStreet, comp);
                    this.fillState(filledFields, comp);
                    this.fillCity(filledFields, comp);
                });

                let finalPostcode = '';
                Object.keys(tempPostcode).forEach(key => {
                    finalPostcode += `${tempPostcode[key]} `;
                });

                this.setField({
                    identifier: `${this.autocompleteIdentifier}_postcode`,
                    data: finalPostcode.trim()
                });

                document.dispatchEvent(new Event('autocomplete:place-change'));

                if (this.validate && typeof this.validate == 'function') {
                    this.$nextTick(() => {
                        this.validate();
                    });
                }

                this.predictions = [];
            },
            emulatePlaceChange(e, opt) {
                this.placeService.getDetails(
                    {
                        placeId: opt.place_id,
                        fields: ['address_component']
                    },
                    (place, status) => {
                        if (
                            status == google.maps.places.PlacesServiceStatus.OK
                        ) {
                            this.setPlaces(place.address_components);
                        } else {
                            console.log(status);
                        }
                    }
                );
            },
            getIsoCodeFromName(val, countries) {
                let iso;
                Object.keys(countries).filter(key => {
                    countries[key].value == val
                        ? (iso = countries[key].code)
                        : null;
                });
                this.currentCountryIso = iso;
            }
        }
    };
}

export default autocomplete;



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/autocomplete.js